import { cva, VariantProps } from 'class-variance-authority';

export const btn = cva(
  [
    'rounded-3xl',
    'h-11',
    'text-sm',
    'text-medium',
    'focus:ring-0',
    'outline-0',
    'disabled:border-neutral-400',
    'disabled:text-neutral-500',
    'inline-flex',
    'flex-row',
    'items-center',
    'whitespace-nowrap',
    'appearance-none',
    'focus-visible:outline-none',
    'focus-visible:outline-2',
    'focus-visible:ring',
    'focus-visible:ring-4',
    'focus-visible:ring-offset-2',
  ],
  {
    variants: {
      padding: {
        true: ['px-6'],
        false: [],
      },
      intent: {
        solid: ['border-2'],
        outlined: ['border-2'],
        text: [],
        link: ['rounded-none'],
        carousel: [
          '!bg-primary-50',
          '!cursor-pointer',
          'text-primary-800',
          'hover:!bg-primary-200',
          'hover:!text-primary-800',
          'focus:!border-black',
          'focus:!border-2',
          'focus:!text-primary-800',
          'focus:!outline-white',
          'focus:!outline-solid',
          'focus:!outline-1',
          'focus:!shadow-[0_0_0_6px_rgba(122,90,169,0.32)]',
          'focus:!ring-2',
          'focus:!ring-white',
        ],
        loader: [],
      },
      isLoading: { true: [] },
      inverted: { false: [] },
      color: {
        primary: [
          'border-primary-600',
          'hover:border-primary-800',
          'focus:border-primary-800',
          'active:border-primary-950',
          'hover:text-white',
          'active:text-primary-950',
        ],
        positive: [
          'border-position-300',
          'hover:border-position-300',
          'active:border-position-300',
          'focus:border-position-500',
          'hover:text-position-500',
          'focus:text-position-500',
          'active:text-position-500',
        ],
        negative: [
          'border-red-400',
          'hover:border-red-400',
          'active:border-red-400',
          'focus:border-red-700',
          'hover:text-red-700',
          'focus:text-red-700',
          'active:text-red-700',
        ],
        neutral: [
          'border-neutral-600',
          'hover:border-neutral-600',
          'focus:border-neutral-600',
          'active:border-neutral-700',
          'hover:text-neutral-600',
          'active:text-neutral-700',
        ],
        white: [
          'border-white',
          'hover:border-white',
          'focus:border-white',
          'active:border-white',
          'hover:text-white',
          'active:text-white',
        ],
      },
      icon: {
        start: ['pl-3'],
        end: ['pr-3'],
        isolated: ['px-0', 'w-11', 'justify-center'],
      },
    },
    compoundVariants: [
      {
        intent: 'solid',
        className: [
          'text-white',
          'hover:text-white',
          'active:text-white',
          'disabled:text-white',
        ],
      },
      {
        intent: ['outlined', 'text'],
        color: 'primary',
        className: ['text-primary-600'],
      },
      {
        intent: ['outlined', 'text'],
        color: 'negative',
        className: ['text-red-400'],
      },
      {
        intent: ['outlined', 'text'],
        color: 'neutral',
        className: ['text-neutral-600'],
      },
      {
        intent: ['outlined', 'text'],
        color: 'white',
        className: 'text-white',
      },
      {
        intent: 'solid',
        color: 'primary',
        className: [
          'bg-primary-600',
          'hover:bg-primary-800',
          'active:bg-primary-950',
          'disabled:bg-neutral-400',
          'focus:bg-primary-800',
        ],
      },
      {
        intent: 'solid',
        color: 'negative',
        className: 'bg-red-400',
      },
      {
        intent: 'outlined',
        color: 'primary',
        className: [
          'hover:bg-primary-600',
          'hover:border-primary-600',
          'border-primary-600',
          'active:bg-primary-600',
          'focus:ring-primary-300',
          'focus:border-black',
          'focus:bg-primary-600',
          'focus:text-white',
        ],
      },
      {
        intent: 'outlined',
        color: 'negative',
        className: [
          'hover:bg-red-100',
          'active:bg-red-300',
          'focus:bg-red-300',
        ],
      },
      {
        intent: 'text',
        className: [
          'hover:!text-primary-950',
          'hover:bg-neutral-50',
          'active:bg-neutral-50',
          'focus:ring-neutral-300',
          'focus:border-black',
        ],
      },
    ],
    defaultVariants: {
      intent: 'solid',
      color: 'primary',
      padding: true,
    },
  }
);

export const icon = cva([], {
  variants: {
    size: {
      sm: ['text-sm'],
      md: ['text-base'],
      lg: ['text-2xl'],
    },
  },
});

export type StyleProps = VariantProps<typeof btn>;
